// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import taskApi from '~/apis/task';
import {
  CREATE_TASK,
  DELETE_TASK,
  GET_TASK_LIST,
  GET_TASK_DETAIL,
  UPDATE_TASK,
  CHANGE_STATUS_TASK,
  CREATE_TASK_JOB,
  EDIT_TASK_JOB,
} from '~/utils/constants/actionType';
import { IQueryParamBase } from '~/utils/interface/common';
import { IQueryCreateTaskJob, IQueryEditTaskJob } from '~/utils/interface/job';
import { IFormTask, IQueryChangeStatusTask, IQueryUpdateTask } from '~/utils/interface/task';

export const createTask = createAsyncThunk(CREATE_TASK, async (payload: IFormTask, { rejectWithValue }) => {
  try {
    const resp = await taskApi.createTask(payload);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getTaskList = createAsyncThunk(
  GET_TASK_LIST,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await taskApi.getTaskList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteTask = createAsyncThunk(DELETE_TASK, async (taskId: string, { rejectWithValue }) => {
  try {
    const resp = await taskApi.deleteTask(taskId);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getTaskDetail = createAsyncThunk(
  GET_TASK_DETAIL,
  async (taskId: string, { rejectWithValue }) => {
    try {
      const resp = await taskApi.getTaskDetail(taskId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateTask = createAsyncThunk(
  UPDATE_TASK,
  async (payload: IQueryUpdateTask, { rejectWithValue }) => {
    try {
      const resp = await taskApi.updateTask(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const changeStatusTask = createAsyncThunk(
  CHANGE_STATUS_TASK,
  async (payload: IQueryChangeStatusTask, { rejectWithValue }) => {
    try {
      const resp = await taskApi.changeStatusTask(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createTaskInJob = createAsyncThunk(
  CREATE_TASK_JOB,
  async (payload: IQueryCreateTaskJob, { rejectWithValue }) => {
    try {
      const res = await taskApi.createTaskJob(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editTaskInJob = createAsyncThunk(
  EDIT_TASK_JOB,
  async (payload: IQueryEditTaskJob, { rejectWithValue }) => {
    try {
      const res = await taskApi.updateJobTask(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
